import { render, staticRenderFns } from "./btable.vue?vue&type=template&id=171fe820&"
import script from "./btable.vue?vue&type=script&lang=js&"
export * from "./btable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports